<template>
  <div>
    <div
      :class="[
        'flex flex-col mx-auto lg:gap-2 overflow-x-hidden max-w-full',
        { 'page-container py-3': route.meta.pageContainer != undefined ? route.meta.pageContainer : true },
      ]">
      <div :class="{ 'pb-4': route.meta.pageContainer != undefined ? route.meta.pageContainer : true }">
        <BreadCrumbs v-if="path" :path="path" />
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRoute } from "vue-router";
import BreadCrumbs from "./BreadCrumbs.vue";

defineProps(["path"]);

const route = useRoute();
</script>
